// extracted by mini-css-extract-plugin
module.exports = {"dashedList":"CompanyPage_dashedList__JB46n","fadeIn":"CompanyPage_fadeIn__VZqnh","fadeInAnimation":"CompanyPage_fadeInAnimation__FvZTV"};